module.exports = __webpack_public_path__ + "fonts/icomoon.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./test/styles/fonts/icomoon.woff?jh9e4u
 ** module id = 165
 ** module chunks = 0
 **/